import {DateAdapter} from '@angular/material/core';
import {DateRange, DefaultMatCalendarRangeStrategy, MatDateRangeSelectionStrategy} from '@angular/material/datepicker';

export class StartTrackingRangeStrategy implements MatDateRangeSelectionStrategy<Date> {
    onStartChange?: (start: Date | null) => void;
    private readonly base: DefaultMatCalendarRangeStrategy<Date>;

    constructor(adapter: DateAdapter<Date>) {
        this.base = new DefaultMatCalendarRangeStrategy<Date>(adapter);
    }

    selectionFinished(date: Date | null, current: DateRange<Date>): DateRange<Date> {
        const result = this.base.selectionFinished(date!, current);
        this.onStartChange?.(result.start && !result.end ? result.start : null);
        return result;
    }

    createPreview(activeDate: Date | null, current: DateRange<Date>): DateRange<Date> {
        return this.base.createPreview(activeDate, current);
    }

    createDrag(dragOrigin: Date, originalRange: DateRange<Date>, newDate: Date): DateRange<Date> | null {
        return this.base.createDrag(dragOrigin, originalRange, newDate);
    }
}
